/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import { RenderSections } from '@components/UI/Common/SectionCommonUI';

/**
 * Renders the Events Common UI component.
 *
 * @param pageBody.pageBody
 * @param {Array} pageBody - Content from api.
 * @param {string} region - Current User Country.
 * @param {string} lang - Current User Language.
 * @param pageBody.region
 * @param pageBody.lang
 * @param pageBody.pageName
 * @returns {ReactElement} Events Common UI Component.
 */
const EventsCommonUI = ({ pageBody, region, lang, pageName, csrData, pageConfig }) => {
  return (
    <Box
      as="section"
      id="centers-section"
      className="container-article btn-center"
    >
      {pageBody && pageBody.length
        ? pageBody.map((section, i) => {
            return (
              <RenderSections
                section={section}
                region={region}
                lang={lang}
                pType="event"
                key={i}
                pageName={pageName}
                pageBody={pageBody}
                csrData={csrData}
                pageConfig={pageConfig}
              />
            );
          })
        : null}
    </Box>
  );
};

export default EventsCommonUI;
